import ToggleLink from "./components/toggleLink/toggleLink";
import Megadrop from "./components/megadrop/megadrop";
import Carousel from "./components/carousell/carousell";
import MobileMenu from "./components/mobileMenu/mobileMenu";
import MobileSearch from "./components/mobileSearch/mobileSearch";
import InputSearch from "./components/inputSearch/inputSearch";
import TabUsability from "./components/tabUsability/tabUsability";
import EpiserverForm from "./components/episerverForm/episerverForm";
import { wrap } from "./components/utilities/utilities";
import { getCookie, setCookie } from "./components/cookie/cookie";
import AutoSubmit from "./components/autoSubmit/autoSubmit";
import AutoComplete from "./libs/autocomplete";
import axios from "axios";
import objectFitImages from "object-fit-images";

/**
 * App
 * This starting point for this application.
 * @version 3.0.0
 * @exports App
 */
export default class App {
	constructor() {
		// Init menu
		new Megadrop();

		// Init mobile menu
		this.mobileMenu = new MobileMenu(
			document.querySelector('[data-type="mobileMenu"]'),
			{
				ajaxPath: mainConfig.menuAjaxPath,
				ajaxActivePane: mainConfig.menuAjaxActivePane,
				searchField: true,
				searchMethod: mainConfig.searchMethod,
				searchPage: mainConfig.searchPage,
				searchParameter: mainConfig.searchParameter,
				searchPlaceholder: mainConfig.searchPlaceholder,
			}
		);

		if (document.querySelector('[data-type="mobileSearch"]')) {
			new MobileSearch(document.querySelector('[data-type="mobileSearch"]'));
		}

		if (document.querySelector('[data-type="inputSearch"]')) {
			new InputSearch(document.querySelector('[data-type="inputSearch"]'));
		}

		// Init toggle link
		new ToggleLink();

		// Init tabUsability
		new TabUsability();

		// Init table wrap for mobile scrolling of tables in rte.
		this._initRteTableWrap();
		// Smooth scrolling to anchor
		this._smoothScrollToAnchor();
		// Init ajaxForm
		this._initAjaxForm();

		// Init episerverForms
		this._initEpiserverForm();

		// Init Fancybox
		this._initFancybox();

		// Init Password Check
		this._initPaswdCheck();

		this._initPaswdCheckReset();

		// Init Password Check if Same
		this._initcheckPassword();

		this._initcheckPasswordReset();

		// Init autosubmit
		new AutoSubmit();

		this._initAutocomplete();

		// Init resetAjaxforms
		this._resetEducationAjaxform();
		this._resetAjaxFilterform();

		this._initScrollToTop();

		this._initLanguageGone();
		// Init LoadMore
		this._loadMore();

		// this._initResetNewpassword();

		this._initErrorbar();

		this._initDropDown();

		objectFitImages();
	}

	_initLanguageGone() {
		window.onscroll = function() {
			myFunction();
		};

		var header = document.getElementById("language");
		var isGone = header.offsetTop;

		function myFunction() {
			if (window.pageYOffset > isGone) {
				document.getElementById("language").style.visibility = "hidden";
			} else {
				document.getElementById("language").style.visibility = "visible";
			}
		}
	}

	/**
	 * Function that initiates the ajax-form functionality.
	 * @private
	 */
	_initAjaxForm() {
		let els = document.querySelectorAll('[data-type="ajaxForm"]');

		if (els.length > 0) {
			import(
				/* webpackChunkName: "ajaxForm" */
				"./components/ajaxForm/ajaxForm"
			).then(AjaxForm => {
				for (let i = 0; i < els.length; i++) {
					let el = els[i];

					if (el.getAttribute("data-ajaxform-initiated") === null) {
						new AjaxForm.default(el);
						el.setAttribute("data-ajaxform-initiated", true);
					}
				}
			});
		}
	}

	_smoothScrollToAnchor() {
		document.querySelectorAll('a[href^="#"]').forEach(anchor => {
			anchor.addEventListener("click", function(e) {
				e.preventDefault();

				const id = this.getAttribute("href").slice(1);
				const target = document.getElementById(id);

				target.scrollIntoView({
					block: "center",
					behavior: "smooth",
				});
			});
		});
	}

	/**
	 * Function that initiates the episerverform functionality.
	 * @private
	 */
	_initEpiserverForm() {
		let els = document.querySelectorAll('[data-type="episerverForm"]');

		if (els.length > 0) {
			for (let i = 0; i < els.length; i++) {
				let el = els[i];

				if (el.getAttribute("data-episerverform-initiated") === null) {
					new EpiserverForm(el);
					el.setAttribute("data-episerverform-initiated", true);
				}
			}
		}
	}

	/**
	 * Function that wraps all tables in rte with a div to enable the scroll-feature in mobile.
	 * @private
	 */
	_initRteTableWrap() {
		let els = document.querySelectorAll(".rte table");

		els.forEach(el => {
			let wrapper = document.createElement("div");
			wrapper.classList.add("table-scrollable");
			wrap(el, wrapper);
		});
	}

	_initFancybox() {
		/* global $ */
		var self = this;
		import(/* webpackChunkName: "jquery" */ "jquery").then(jquery => {
			window.$ = window.jQuery = jquery.default;
			import(/* webpackChunkName: "fancybox" */ "@fancyapps/fancybox").then(
				() => {
					$('[data-fancybox="booking"]').fancybox({
						afterLoad: function() {
							self._initAjaxForm();
						},
					});
				}
			);
		});
	}

	/**
	 * Initiates autocomplete on searchbars
	 */
	_initAutocomplete() {
		if (
			document.getElementById("searchbar-input") &&
			document
				.getElementById("searchbar-input")
				.getAttribute("data-autocompleteUrl")
		) {
			new AutoComplete({
				selector: "#searchbar-input",
				source: (term, response) => {
					term = encodeURIComponent(term);
					const field = document.getElementById("searchbar-input");
					const url = field.getAttribute("data-autocompleteUrl");
					const name = field.getAttribute("name");

					axios({
						url: `${url}?${name}=${term}`,
						method: "GET",
						headers: {
							"X-Requested-With": "XMLHttpRequest",
						},
					})
						.then(res => {
							if (res.status === 200) {
								if (res.data.suggestions.length > 0) {
									response(res.data.suggestions);
								}
							} else {
								alert("An error occured, try again later.");
							}
						})
						.catch(e => {
							console.log(e);
						});
				},
			});
		}
	}

	_initScrollToTop() {
		window.onscroll = function() {
			scrollFunction();
		};

		function scrollFunction() {
			var scrollToTopBtn = document.getElementById("scrollToTop");

			if (
				document.body.scrollTop > 20 ||
				document.documentElement.scrollTop > 20
			) {
				scrollToTopBtn.style.display = "block";
			} else {
				scrollToTopBtn.style.display = "none";
			}
		}
		window.onscroll = function() {
			scrollToTop();
		};
		function scrollToTop() {
			var currentPosition =
				document.documentElement.scrollTop || document.body.scrollTop;
			if (currentPosition > 0) {
				window.requestAnimationFrame(scrollToTop);
				window.scrollTo(0, currentPosition - currentPosition / 8);
			}
		}
	}
	/**
	 * Initiates resetAjaxforms
	 */
	_resetEducationAjaxform() {
		if (
			document.getElementById("educationFilterForm") &&
			document.getElementById("educationFilterFormReset")
		) {
			document
				.getElementById("educationFilterFormReset")
				.addEventListener("click", () => {
					const educationFilterSelects = document.querySelectorAll(
						"#educationFilterForm select"
					);

					if (educationFilterSelects) {
						educationFilterSelects.forEach(filterSelect => {
							filterSelect.selectedIndex = 0;
						});
					}

					document.getElementById("educationFilterFormSubmit").click();
				});
		}
	}

	_resetAjaxFilterform() {
		const filterForm = document.getElementById("filterForm");

		if (filterForm) {
			const searchInput = document.getElementById("searchbar-input");
			const searchInputReset = document.querySelector(".searchbar__reset");
			const filterFormReset = document.getElementById("filterFormReset");

			if (filterFormReset) {
				filterFormReset.addEventListener("click", e => {
					e.preventDefault();
					filterForm.reset();

					if (searchInput) {
						searchInput.value = "";
					}

					document.getElementById("filterFormSubmit").click();
				});
			}

			if (searchInputReset) {
				searchInputReset.addEventListener("click", e => {
					e.preventDefault();

					if (searchInput) {
						searchInput.value = "";
					}
				});
			}
		}
	}

	/**
	 * Initiates loadMore
	 * @private
	 */
	_loadMore() {
		if (document.querySelectorAll('[data-type="loadMore"]').length > 0) {
			import(
				/* webpackChunkName: "loadMore" */
				"./components/loadMore/loadMore"
			).then(LoadMore => {
				new LoadMore.default();
			});
		}

		if (document.querySelectorAll('[data-type="autosubmit"]').length > 0) {
			import(
				/* webpackChunkName: "autoSubmit" */
				"./components/autoSubmit/autoSubmit"
			).then(AutoSubmit => {
				new AutoSubmit.default();
			});
		}
	}

	/**
	 * Initiates errorbar with click event
	 * @private
	 */
	_initErrorbar() {
		const errorBars = document.querySelectorAll(".error-bar");

		errorBars.forEach(errorBar => {
			const errorAcceptBtn = errorBar.querySelector(
				".error-bar__content--close"
			);
			const cookieName =
				"hbAcceptError-" + errorBar.getAttribute("data-error-id");

			if (errorAcceptBtn) {
				if (!getCookie(cookieName)) {
					errorBar.classList.remove("error-bar--hidden");

					errorAcceptBtn.addEventListener("click", e => {
						e.preventDefault();
						setCookie(cookieName, true);
						errorBar.classList.add("error-bar--hidden");
					});
				}
			}
		});
	}

	_initPaswdCheck() {
		var myInput = document.getElementById("password");
		var letter = document.getElementById("letter");
		var capital = document.getElementById("capital");
		var number = document.getElementById("number");
		var length = document.getElementById("length");
		var special = document.getElementById("special");

		if (
			myInput === null ||
			letter === null ||
			capital === null ||
			number === null ||
			length === null ||
			special === null
		) {
			return;
		}

		// When the user starts to type something inside the password field
		myInput.onkeyup = function() {
			// Validate lowercase letters
			var lowerCaseLetters = /[a-zåäö]/g;
			if (myInput.value.match(lowerCaseLetters)) {
				letter.classList.remove("invalid");
				letter.classList.add("valid");
			} else {
				letter.classList.remove("valid");
				letter.classList.add("invalid");
			}

			// Validate special characters
			var specialCh = /[^a-zåäöA-ZÅÄÖ\d]/;
			if (myInput.value.match(specialCh)) {
				special.classList.remove("invalid");
				special.classList.add("valid");
			} else {
				special.classList.remove("valid");
				special.classList.add("invalid");
			}

			// Validate capital letters
			var upperCaseLetters = /[A-ZÅÄÖ]/g;
			if (myInput.value.match(upperCaseLetters)) {
				capital.classList.remove("invalid");
				capital.classList.add("valid");
			} else {
				capital.classList.remove("valid");
				capital.classList.add("invalid");
			}

			// Validate numbers
			var numbers = /[0-9]/g;
			if (myInput.value.match(numbers)) {
				number.classList.remove("invalid");
				number.classList.add("valid");
			} else {
				number.classList.remove("valid");
				number.classList.add("invalid");
			}

			// Validate length
			if (myInput.value.length >= 8) {
				length.classList.remove("invalid");
				length.classList.add("valid");
			} else {
				length.classList.remove("valid");
				length.classList.add("invalid");
			}
		};
	}

	/**
	 * 	 * Function that checks if password is matching.
	 * @private
	 */
	_initcheckPassword() {
		const button = document.getElementById("checkPassword");
		if (button === null) {
			return;
		}
		button.addEventListener("click", event => {
			let password = document.getElementById("password").value;
			let cnfrmPassword = document.getElementById("cnfrm-password").value;
			let message = document.getElementById("message");

			if (password.length !== 0) {
				if (password === cnfrmPassword) {
					message.textContent = "";
				} else {
					event.preventDefault();
					message.textContent = "Lösenordet matchar inte";
				}
			}
		});
	}

	/**
	 * 	 * Function that checks if password is matching on reset page.
	 * @private
	 */

	_initPaswdCheckReset() {
		var myInput = document.getElementById("reset-password");
		var letter = document.getElementById("reset-letter");
		var capital = document.getElementById("reset-capital");
		var number = document.getElementById("reset-number");
		var length = document.getElementById("reset-length");
		var special = document.getElementById("reset-special");

		if (
			myInput === null ||
			letter === null ||
			capital === null ||
			number === null ||
			length === null ||
			special === null
		) {
			return;
		}

		// When the user starts to type something inside the password field
		myInput.onkeyup = function() {
			// Validate lowercase letters
			var lowerCaseLetters = /[a-zåäö]/g;
			if (myInput.value.match(lowerCaseLetters)) {
				letter.classList.remove("invalid");
				letter.classList.add("valid");
			} else {
				letter.classList.remove("valid");
				letter.classList.add("invalid");
			}

			// Validate special characters
			var specialCh = /[^a-zåäöA-ZÅÄÖ\d]/;
			if (myInput.value.match(specialCh)) {
				special.classList.remove("invalid");
				special.classList.add("valid");
			} else {
				special.classList.remove("valid");
				special.classList.add("invalid");
			}

			// Validate capital letters
			var upperCaseLetters = /[A-ZÅÄÖ]/g;
			if (myInput.value.match(upperCaseLetters)) {
				capital.classList.remove("invalid");
				capital.classList.add("valid");
			} else {
				capital.classList.remove("valid");
				capital.classList.add("invalid");
			}

			// Validate numbers
			var numbers = /[0-9]/g;
			if (myInput.value.match(numbers)) {
				number.classList.remove("invalid");
				number.classList.add("valid");
			} else {
				number.classList.remove("valid");
				number.classList.add("invalid");
			}

			// Validate length
			if (myInput.value.length >= 8) {
				length.classList.remove("invalid");
				length.classList.add("valid");
			} else {
				length.classList.remove("valid");
				length.classList.add("invalid");
			}
		};
	}

	_initcheckPasswordReset() {
		const button = document.getElementById("resetCheckPassword");
		if (button === null) {
			return;
		}
		button.addEventListener("click", event => {
			let password = document.getElementById("password").value;
			let cnfrmPassword = document.getElementById("cnfrm-reset-password").value;
			let message = document.getElementById("message");

			if (password.length !== 0) {
				if (password === cnfrmPassword) {
					message.textContent = "";
				} else {
					event.preventDefault();
					message.textContent = "Lösenordet matchar inte";
				}
			}
		});
	}

	/**
	 * 	 * Function for dropdown .
	 *
	 */

	_initDropDown() {
		if (document.getElementById("dropdown-btn-1") !== null) {
			const dropdownButton1 = document.getElementById("dropdown-btn-1");
			const dropdownContent1 = document.getElementById("dropdown1");

			dropdownButton1.addEventListener("click", () => {
				this.toggleDropdown(dropdownContent1);
			});

			const dropdownItems1 = dropdownContent1.getElementsByTagName("li");
			for (const item of dropdownItems1) {
				item.addEventListener("click", () => {
					dropdownContent1.style.display = "none";
				});
			}
		}
		if (document.getElementById("dropdown-btn-2") !== null) {
			const dropdownButton2 = document.getElementById("dropdown-btn-2");
			const dropdownContent2 = document.getElementById("dropdown2");

			dropdownButton2.addEventListener("click", () => {
				this.toggleDropdown(dropdownContent2);
			});
			const dropdownItems2 = dropdownContent2.getElementsByTagName("li");
			for (const item of dropdownItems2) {
				item.addEventListener("click", () => {
					dropdownContent2.style.display = "none";
				});
			}
		}
	}
	toggleDropdown(dropdownContent) {
		if (dropdownContent.style.display === "block") {
			dropdownContent.style.display = "none";
		} else {
			dropdownContent.style.display = "block";
		}
	}
}
